export default __webpack_public_path__ + "static/KeyBank-logo.png";